import { useState} from 'react'
import {  useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
export default function Register() {
  const  [isLoading, setIsLoading] = useState(false);
  const [messageError,setMessageError] = useState("");
  let navigate = useNavigate();
  function handleRegister(values) {
    setIsLoading(true);
    axios.post(`https://ecommerce.routemisr.com/api/v1/auth/signup`, values)
    .then(({ data }) => { // Destructuring to get `data`
      console.log(data);
      if (data.message === 'success') {
        setIsLoading(false);
        navigate("/login");
      }
    })
    .catch((error) => {
      setIsLoading(false)
      console.log(error.response?.data); // Safely access response data
      setMessageError(`${error.response?.data?.statusMsg}: ${error.response?.data?.message}`);
    });
    
  }
  let validation = Yup.object({
    name: Yup.string().required('name is required').min(3, "min length is 3").max(10, "max length is 10"),
    email: Yup.string().required('email is required').email("email not valid"),
    password: Yup.string().required('password is required').matches(/^[A-Z][a-z0-9]{5,10}$/ ,"password must match"),
    rePassword: Yup.string().required('rePassword is required').oneOf([Yup.ref("password")]),
    phone: Yup.string().required('phone is required').matches(/01[0125][0-9]{8}$/, "phone must be valid a number"),
  })
  let formik = useFormik({
    initialValues:{
      "name": "",
      "email": "",
      "password": "",
      "rePassword": "",
      "phone":""
    },
    validationSchema: validation,
    onSubmit:handleRegister
  })
  return (
    <>
    <Helmet>
      <title>Register</title>
    </Helmet>
      <div className="w-75 mt-5">
        {messageError.length > 0 ? <div className="alert alert-danger">{messageError}</div> : null}
        <form onSubmit={formik.handleSubmit} >
          <label htmlFor="name">Name</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.name} type="text" name="name" id="name" />
          {formik.errors.name && formik.touched.name ?<div className="alert alert-danger">{formik.errors.name}</div> : null}

          <label htmlFor="email">Email:</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.email} type="email" name="email" id="email" />
          {formik.errors.email && formik.touched.email ?<div className="alert alert-danger">{formik.errors.email}</div> : null}


          <label htmlFor="password">Password</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.password} type="password" name="password" id="password" />
          {formik.errors.password && formik.touched.password ?<div className="alert alert-danger">{formik.errors.password}</div> : null}

          <label htmlFor="rePassword">Repassword</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.rePassword} type="password" name="rePassword" id="rePassword" />
          {formik.errors.rePassword && formik.touched.rePassword ?<div className="alert alert-danger">{formik.errors.rePassword}</div> : null}

          <label htmlFor="phone">Phone</label>
          <input onBlur={formik.handleBlur} className='form-control mb-2' onChange={formik.handleChange} value={formik.values.phone} type="text" name="phone" id="phone" />
          {formik.errors.phone && formik.touched.phone ?<div className="alert alert-danger">{formik.errors.phone}</div> : null}

          {isLoading? <button type='button' className='btn bg-success  text-white'><i className='fas fa-spinner fa-spin'></i></button> : <button disabled={!(formik.isValid && formik.dirty)} type='submit' className='btn bg-success  text-white'>Register</button>}
        </form>
      </div>
    </>
  )
}
